/**
 * @description 该文件仅存放用户状态相关类型(用户级别), 主要是/web/user/status接口返回的数据类型
 * 账户级别的类型应放在customer.ts文件中
 */
import { CategoryEnum, ClearingEnum, CustomerTypeEnum, LicenseEnum } from './customer';

// /web/user/status接口返回的账户类型, 注意跟清算类型ClearingEnum作区分, 两者不一样
// 也需要注意, 这里拿到的类型跟customer服务中的不一致, customer服务未来可能会WebUser保持统一, 但目前还不一致(2024-6-17)
export enum WebUserAccountTypeEnum {
    BS = 'bs',
    VIRTUAL = 'virtual',
    FD = 'fd',
    ND = 'nd'
}

// api/v2/web/user/status接口中account的status类型
export enum WebUserStatusEnum {
    UNACCOUNT = 'UNACCOUNT',
    OPENED = 'OPENED',
    FUNDED = 'FUNDED',
    // 转户的状态
    CANCELLED = 'CANCELLED'
}

export interface UserInfo {
    email: string;
    emailActive: boolean;
    inviteCode: string;
    loginPassword: boolean;
    phone: string;
    telCode: string;
    tradePassword: boolean;
    uuid: number;
    username: string | null;
    uuidHash: string;
}

export interface ApiWebUserDataWithCustomerId {
    license: LicenseEnum;
    status: WebUserStatusEnum;
    customerId: number;
    accountId?: number;
    accountType: WebUserAccountTypeEnum;
    userInfo: UserInfo;
    tradePermission?: string[]; // 已开通的交易权限的数组(当前账户), 如果没有开通的内容则返回null
    clearing: ClearingEnum;
    customerType: CustomerTypeEnum;
    category: CategoryEnum;
}

export type AccountItemType = Omit<ApiWebUserDataWithCustomerId, 'userInfo' | 'tradePermission'>;

// /web/user/status不传customerId的情况下返回的数据结构类型
export interface ApiWebUserData {
    actualAccountInfo: {
        accountList: AccountItemType[];
        // 当前账户的customer_id
        currentCustomerId?: number;
    };
    // 只返回currentCustomerId对应的交易权限
    tradePermission: string[]; // 已开通的交易权限的数组(当前账户)
    userInfo: UserInfo;
}

// WebUserDataType中只存放用户状态相关的(用户级别的), 由//api/v2/web/user/status接口拿到的, 或者由//api/v2/web/user/status衍生而出的数据
// 其他数据不建议放在这个类型下, 不然越改越大难以维护
// !!!!!加属性, 一定要加注释, 说明该属性的作用和来源(源自哪个接口或者由某些属性计算而来等)!!!!!
// actualAccountInfo是可选的, 使用customerId来直接请求/api/v2/web/user/status接口的时候, 是没有这个属性的
export interface CurrentUserType
    extends Omit<ApiWebUserData, 'actualAccountInfo'>,
        Partial<Pick<ApiWebUserData, 'actualAccountInfo' | 'actualAccountInfo'>> {
    // 当前账户信息, 来源: 通过/api/v2/web/user/status衍生计算得到
    currentAccount: AccountItemType;
}
